import { render, staticRenderFns } from "./ModuleTenantForm.vue?vue&type=template&id=4ad6057e&scoped=true"
import script from "./ModuleTenantForm.vue?vue&type=script&lang=js"
export * from "./ModuleTenantForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleTenantForm.vue?vue&type=style&index=0&id=4ad6057e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad6057e",
  null
  
)

export default component.exports